module.exports = __webpack_public_path__ + "img/changegroupphoto.5b76e0f1.png";